'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createVisitorThread = createVisitorThread;

var _noAuthApiClient = require('../../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _wrappedPortalIdParser = require('../../utils/wrappedPortalIdParser');

var _wrappedPortalIdParser2 = _interopRequireDefault(_wrappedPortalIdParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createVisitorThread(_ref) {
  var sessionId = _ref.sessionId,
      messageId = _ref.messageId;

  return _noAuthApiClient2.default.post('livechat/v1/thread/visitor', {
    query: {
      sessionId: sessionId,
      welcomeMessageId: messageId,
      portalId: (0, _wrappedPortalIdParser2.default)('createVisitorThread client')
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./js/threads/clients/createVisitorThread.js
// module id = 645
// module chunks = 2 3